/* ===========================================================================
   MineCozy — Hiệu ứng hiện dần khi cuộn trang (bản tối giản)

   JS chỉ làm đúng hai việc:
     1. Phát hiện section lọt vào khung nhìn rồi gắn class `cz-reveal--done`.
     2. Đặt `transition-delay` cho từng phần tử để chúng hiện lần lượt theo thứ
        tự mắt đọc (trên xuống dưới, cùng hàng thì trái sang phải).

   Chuyển động thực tế do CSS transition trong cz-scroll-reveal.css lo. Xem file
   đó để biết vì sao đã bỏ transform và bỏ Web Animations API.

   Section nằm sẵn trong khung nhìn lúc mới mở trang thì hiện thẳng, không hiệu
   ứng — đó là lúc trình duyệt bận nhất, thêm animation chỉ tổ gây giật.

   ⚠ ITEM_SELECTOR phải khớp với danh sách trong cz-scroll-reveal.css.
   =========================================================================== */

(function () {
  'use strict';

  // Báo cho script nội tuyến trong theme.liquid biết file này đã chạy được,
  // để nó không gỡ class `cz-js` (cơ chế dự phòng khi JS lỗi mạng).
  window.__czRevealReady = true;

  var STAGGER = 110; // độ trễ giữa hai phần tử liền nhau (ms)
  var MAX_STAGGER_STEPS = 5; // phần tử thứ 6 trở đi dùng chung độ trễ, khỏi chờ lâu
  var ROW_TOLERANCE = 48; // lệch dọc dưới mức này thì coi như cùng một hàng

  var ITEM_SELECTOR = [
    '[class*="__eyebrow"]',
    '[class*="__heading"]',
    '[class*="__subheading"]',
    '[class*="__tagline"]',
    '[class*="__description"]',
    '[class*="__text"]',
    '[class*="__btn"]',
    '[class*="__form"]',
    '.cz-feature',
    '.cz-scene',
    '.cz-card',
    '.cz-testimonial',
    '.cz-about-value',
    '.cz-about-story__stat',
    '.cz-trustbar__item',
    '.cz-faq__item',
    '.cz-instagram__row'
  ].join(',');

  /** Phần tử con cần hiện, đã bỏ phần tử lồng nhau và xếp theo vị trí nhìn thấy */
  function collectItems(section) {
    var all = Array.prototype.slice.call(section.querySelectorAll(ITEM_SELECTOR));
    if (!all.length) return [];

    var items = [];
    all.forEach(function (el) {
      if (all.some(function (other) { return other !== el && other.contains(el); })) return;
      var rect = el.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return;
      items.push({ el: el, top: rect.top, left: rect.left });
    });

    items.sort(function (a, b) {
      if (Math.abs(a.top - b.top) > ROW_TOLERANCE) return a.top - b.top;
      return a.left - b.left;
    });

    return items.map(function (entry) { return entry.el; });
  }

  function revealWithStagger(section) {
    var items;
    try {
      items = collectItems(section);
    } catch (error) {
      items = [];
    }

    items.forEach(function (el, index) {
      el.style.transitionDelay = Math.min(index, MAX_STAGGER_STEPS) * STAGGER + 'ms';
    });

    section.classList.add('cz-reveal--done');
  }

  function revealInstantly(section) {
    section.classList.add('cz-reveal--instant', 'cz-reveal--done');
  }

  function revealEverything() {
    var sections = document.querySelectorAll('.cz-reveal:not(.cz-reveal--done)');
    Array.prototype.forEach.call(sections, revealInstantly);
  }

  function init() {
    var sections = document.querySelectorAll('.cz-reveal:not(.cz-reveal--done)');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      revealEverything();
      return;
    }

    // Phần đang nhìn thấy ngay lúc mở trang thì hiện thẳng; phần còn lại chờ cuộn
    var pending = [];
    Array.prototype.forEach.call(sections, function (section) {
      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        revealInstantly(section);
      } else {
        pending.push(section);
      }
    });

    if (!pending.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          // Hoãn sang khung hình kế tiếp: collectItems phải đọc toạ độ nhiều
          // phần tử (buộc trình duyệt tính lại layout), làm ngay trong callback
          // là chen vào đúng khung hình đang cuộn.
          requestAnimationFrame(function () {
            revealWithStagger(entry.target);
          });
        });
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );

    pending.forEach(function (section) {
      observer.observe(section);
    });

    // Bảo hiểm: nếu IntersectionObserver không hoạt động, sau 3s cho hiện hết
    setTimeout(function () {
      var stuck = pending.filter(function (section) {
        if (section.classList.contains('cz-reveal--done')) return false;
        var rect = section.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });
      if (stuck.length) revealEverything();
    }, 3000);
  }

  function safeInit() {
    try {
      init();
    } catch (error) {
      revealEverything();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }

  document.addEventListener('shopify:section:load', safeInit);
})();
